export enum MedicalSourceType {
    diagnosis = 1,
    vitalSign = 2,
    allergy = 3,
    chiefComplaint = 4,
}
